import {useTranslation} from "react-i18next";
import {useState, useEffect} from "react";
import NavBreadcrum from "components/NavBreadcrum";
import navs from "./navs";
import axiApi from "ApiCaller";
import AssetStatus from "./widgets/AssetStatus";
import AssetsFraction from "./widgets/AssetsFraction";
import IslandStatus from "./widgets/IslandStatus";
import DownloadTypes from "./widgets/DownloadTypes";
import WasteModelTypes from "./widgets/WasteModelTypes";
import WasteVolumeFraction from "./widgets/WasteVolumeFraction";

const ReportExecutive = () => {
    const {t} = useTranslation("routes");
    const [widgets, setWidgets] = useState({
        assetStatus: null,
        assetsFraction: null,
        assetsIslands: null,
        assetsDownloadType: null,
        wasteModelType: null,
    });

    const bread = [
        {name: t("labels.reports"), url: "/reports/", current: false},
        {name: t("labels.executive"), current: true},
    ];

    useEffect(() => {
        axiApi
            .get("/api/reports/executive/")
            .then((res) => {
                // console.log(res.data);
                if (res.data && res.data.status) {
                    const widgetData = {};

                    const widgetMapping = {
                        // 'assets_status_01': 'registerWidget',
                        assets_status_01: "assetStatus",
                        assets_fraction_01: "assetsFraction",
                        assets_islands_01: "assetsIslands",
                        assets_download_type_01: "assetsDownloadType",
                        waste_model_type_01: "wasteModelType",
                        waste_volume_fraction_01: "wasteVolumeFraction",
                    };

                    Object.keys(widgetMapping).forEach((modelId) => {
                        if (res.data[modelId]) {
                            const stateKey = widgetMapping[modelId];
                            widgetData[stateKey] = res.data[modelId];
                        }
                    });

                    setWidgets(widgetData);
                    // console.log("Widgets cargados:", Object.keys(widgetData));
                }
            })
            .catch((error) => {
                console.error("Error fetching report data:", error);
            });
    }, []);

    // const hasWidgets = Object.values(widgets).some((widget) => widget !== null);

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <h3 className="mt-2">Informe Ejecutivo</h3>

            <div className="container-fluid p-0">
                {/* Primera fila de gráficos */}
                <div className="row row-eq-height">
                    <div className="col-6">
                        {widgets.assetStatus && (
                            <div className="h-100">
                                <AssetStatus data={widgets.assetStatus} />
                            </div>
                        )}
                    </div>

                    <div className="col-6">
                        {widgets.assetsFraction && (
                            <div className="h-100">
                                <AssetsFraction data={widgets.assetsFraction} />
                            </div>
                        )}
                    </div>
                </div>

                {/* Segunda fila de gráficos */}
                <div className="row row-eq-height mt-3">
                    <div className="col-8">
                        {widgets.assetsIslands && (
                            <div className="h-100">
                                <IslandStatus data={widgets.assetsIslands} />
                            </div>
                        )}
                    </div>

                    <div className="col-4">
                        {widgets.assetsDownloadType && (
                            <div className="h-100">
                                <DownloadTypes
                                    data={widgets.assetsDownloadType}
                                />
                            </div>
                        )}
                    </div>
                </div>

                {/* Tercera fila de gráficos */}
                <div className="row row-eq-height mt-3">
                    <div className="col-6">
                        {widgets.wasteModelType && (
                            <div className="h-100">
                                <WasteModelTypes
                                    data={widgets.wasteModelType}
                                />
                            </div>
                        )}
                    </div>

                    <div className="col-6">
                        {widgets.wasteVolumeFraction && (
                            <div className="h-100">
                                <WasteVolumeFraction
                                    data={widgets.wasteVolumeFraction}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ReportExecutive;
